import React from "react"
import {MutationFunctionOptions} from "@apollo/client"
import {Mutation as ApolloMutation} from "@apollo/client/react/components"
import {getErrorMessage} from "../../lang/formatError"

export interface MutationComponentProps extends MutationFunctionOptions {}

/** @deprecated don't be using apollo components, use hooks */
const Mutation: React.FC<MutationComponentProps> = ({children, ...props}) => {
  return (
    <ApolloMutation {...props}>
      {(mutation, apollo) => children((...args) => mutation(...args), {...apollo, errorMsg: getErrorMessage(apollo.error)})}
    </ApolloMutation>
  )
}

export default Mutation
